import { lazy } from "react";

// Lazy load auth views
const Login = lazy(() => import("@/views/auth/Login"));
const Register = lazy(() => import("@/views/auth/Register"));
const ForgotPassword = lazy(() => import("@/views/auth/ForgotPassword"));
const AdminLogin = lazy(() => import("@/views/auth/AdminLogin"));

/**
 * Authentication Routes Configuration
 * These routes should only be accessible to non-authenticated users
 */
export const authRoutes = [
  {
    path: "/login",
    element: Login,
    guest: true,
    title: "Login - Subrahmanya Rudraksha",
  },
  {
    path: "/register",
    element: Register,
    guest: true,
    title: "Register - Subrahmanya Rudraksha",
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
    guest: true,
    title: "Forgot Password - Subrahmanya Rudraksha",
  },
  {
    path: "/admin/login",
    element: AdminLogin,
    guest: true,
    title: "Admin Login - Subrahmanya Rudraksha",
  },
];

export default authRoutes;
